import React from 'react';

const Header = ({ showExpertButton = false, title }) => (
  <header className="w-full bg-white border-b border-gray-100 py-4 px-6 flex items-center justify-between shadow-sm">
    <div className="flex items-center gap-3">
      <img
        src="/sprinto-logo.png"
        alt="Sprinto Logo"
        className="h-10 w-10 rounded bg-black"
        style={{ objectFit: 'contain' }}
      />
      <span className="text-2xl font-semibold text-gray-900 tracking-tight">
        {title || 'Sprinto'}
      </span>
    </div>
    
    {showExpertButton && (
      <button className="px-4 py-2 bg-gray-900 text-white font-light text-sm hover:bg-gray-800 transition-colors">
        Talk to an expert
      </button>
    )}
  </header>
);

export default Header; 